<template>
  <section>
    <img width="300" height="117.3" v-scroll-reveal="{ delay: 0 }" class="logo" alt="Diwa Studio Logo" src="@/assets/img/diwa-logo.png">
    <h1 v-scroll-reveal="{ delay: 300 }">{{ data_landingMessage[this.lang] }}</h1>
  </section>
</template>

<script>
export default {
  name: 'Landing',
  props: {
    lang: { type: String, default: 'EN' }
  },
  data() {
    return {
      data_landingMessage: {
        EN: 'Helping brands thrive online',
        ES: 'Creamos marcas éxitosas online'
      }
    }
  }
}
</script>

<style scoped>
  .logo {
    max-width: 300px;
    align-self: end;
  }

  h1 {
    align-self: start;
    font-weight: 500;
    font-size: var(--lg-font-size);
    margin-top: 20px;
    line-height: 1.1em;
    letter-spacing: 1px;
  }

  @media (max-width: 414px) {
    .logo {
      width: 75%;
      height: auto;
    }

    h1 {
      font-size: 1.5em;
    }
  }
</style>
